import React, { useState, useEffect } from 'react';
import { FiCheck, FiPlus } from 'react-icons/fi';
import client from '../api/client';

const MILESTONE_TYPES = [
  { key: 'FIRST_WALK', label: 'First Walk' },
  { key: 'FIRST_BOWEL_MOVEMENT', label: 'First Bowel Movement' },
  { key: 'FIRST_URINATION', label: 'First Urination' },
  { key: 'RETURNED_DRIVING', label: 'Returned to Driving' },
  { key: 'RETURNED_WORK', label: 'Returned to Work' },
  { key: 'RESUMED_EXERCISE', label: 'Resumed Exercise' },
  { key: 'GAS_PAIN_RESOLVED', label: 'Gas Pain Resolved' },
  { key: 'DRAIN_REMOVED', label: 'Drain Removed' },
  { key: 'CATHETER_REMOVED', label: 'Catheter Removed' },
];

export default function MilestoneTracker() {
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMilestones = async () => {
    try {
      const res = await client.get('/recovery/milestones');
      setMilestones(res.data || []);
    } catch {
      // silently fail
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMilestones(); }, []);

  const handleMark = async (milestoneType) => {
    const today = new Date().toISOString().split('T')[0];
    try {
      await client.put('/recovery/milestones', {
        milestoneType,
        achievedDate: today,
      });
      fetchMilestones();
    } catch {
      alert('Failed to save milestone.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await client.delete(`/recovery/milestones/${id}`);
      fetchMilestones();
    } catch {
      alert('Failed to delete milestone.');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white" />
      </div>
    );
  }

  const achievedMap = {};
  milestones.forEach(m => { achievedMap[m.milestoneType] = m; });

  return (
    <div className="space-y-3">
      {MILESTONE_TYPES.map(({ key, label }) => {
        const achieved = achievedMap[key];
        return (
          <div
            key={key}
            className={`flex items-center gap-3 p-4 rounded-xl transition ${
              achieved ? 'bg-green-500/10' : 'bg-white/5'
            }`}
          >
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
              achieved ? 'bg-green-500/20' : 'bg-white/10'
            }`}>
              {achieved ? (
                <FiCheck className="w-4 h-4 text-green-400" />
              ) : (
                <span className="w-2 h-2 rounded-full bg-white/30" />
              )}
            </div>
            <div className="flex-1">
              <p className={`font-medium ${achieved ? 'text-green-300' : 'text-white/70'}`}>{label}</p>
              {achieved && (
                <p className="text-xs text-white/40 mt-0.5">{achieved.achievedDate}</p>
              )}
            </div>
            {achieved ? (
              <button
                onClick={() => handleDelete(achieved.id)}
                className="text-xs text-white/30 hover:text-red-400 transition"
              >
                Remove
              </button>
            ) : (
              <button
                onClick={() => handleMark(key)}
                className="flex items-center gap-1 text-xs text-primary-400 hover:text-primary-300 transition"
              >
                <FiPlus size={12} /> Mark achieved
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
